$(function() {
    let normalSlide;

    const setupSwiper = function() {
        let windowWidth = $(window).width();

        if ($(".normal_slide li").length > 1) {
            if (windowWidth <= 768) {
                if (normalSlide === undefined) {
                    normalSlide = new Swiper(".normal_slide", {
                        loop: true,
                        slidesPerView: 1,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        },
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                    });
                }
            } else {
                if (normalSlide !== undefined) {
                    normalSlide.destroy();
                    normalSlide = undefined;
                }
            }
        }
    };

    setupSwiper();

    $(window).on('resize', function() {
        setupSwiper();
    });
});